module.exports = "/images/Logo_AIW.svg?d8215ccab819b213fba9ae04b6384751";